var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.btnRequirementsMet)?_c('b-button',{staticClass:"w-100",attrs:{"id":"document-download","disabled":_vm.busy,"variant":"outline-primary"},on:{"click":_vm.handleDownload}},[_vm._v(" "+_vm._s(_vm.$t('processes.sidebar.download_generated_starting_document'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }